import {
  isSupported,
  getAnalytics,
  setAnalyticsCollectionEnabled,
  logEvent as log,
  EventNameString,
  EventParams
} from 'firebase/analytics'
import Rollbar, { Configuration } from 'rollbar'
import app from '@/modules/firebase'

interface ErrorParams {
  description?: string
  code?: string
  path?: string
  component?: string
}

const rollbar = new Rollbar({
  accessToken: import.meta.env.VITE_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: import.meta.env.MODE
  }
})

let analytics: any = null

if (!import.meta.env.DEV && !app.options.projectId?.startsWith('demo-')) {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app)
        setAnalyticsCollectionEnabled(analytics, true)
      }
    })
    .catch((err) => {
      console.warn(
        'Firebase Analytics is not supported in this environment:',
        err
      )
    })
}

export function configureLogging(config: Configuration) {
  rollbar.configure(config)
}

export function logEvent(
  eventType: EventNameString | string,
  params?: EventParams | { [key: string]: string | number }
) {
  if (analytics) {
    log(analytics, eventType, params)
  } else {
    console.debug(`[Analytics Stub] Event: ${eventType}`, params)
  }
}

export function logInfo(message: string, customParams?: ErrorParams) {
  if (import.meta.env.DEV) {
    console.info(message)
  }
  rollbar.info(message, customParams)
}

export function logError(
  message: string,
  error: Error,
  customParams?: ErrorParams
) {
  if (import.meta.env.DEV) {
    console.error(error)
  }
  rollbar.error(message, error, customParams)
}
